module.exports = __webpack_public_path__ + "frontend/images/landlords/landlords-writing-pad-xs-57cd603ecf3ab37dcbdc533a199f91cc.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/landlords/landlords-writing-pad-xs.png
// module id = 380
// module chunks = 2